import React from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import { Outlet } from "react-router-dom";

function Layout() {
  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
      {/* Top Banner */}
      <div style={{ flexShrink: 0 }}>
        <Header />
      </div>

      <div style={{ display: "flex", flex: 1 }}>
        <Sidebar />
        <main style={{ flex: 1, padding: "20px" }}>
          <Outlet /> {/* <-- This is where page content loads */}
        </main>
      </div>

      {/* Footer */}
      <div style={{ flexShrink: 0 }}>
        <Footer />
      </div>

    </div>
  );
}

export default Layout;
